import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';

import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';
import { UiInputModule } from '@cigna/shared/angular/input-ui';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { UiCollapsibleModule } from '@cigna/shared/angular/collapsible-ui';
import { UiModalModule } from '@cigna/shared/angular/modal-ui';
import { ChcpShellUiModule } from '@cigna/chcp/shell/ui';
import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { EvernorthHeaderComponent } from './evernorth-header/evernorth-header.component';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';
import { EvernorthFooterComponent } from './evernorth-footer/evernorth-footer.component';
import { EvernorthLogoComponent } from './evernorth-logo/evernorth-logo.component';
import { EvernorthSearchComponent } from './evernorth-search/evernorth-search.component';
import { DialogEvernorthHelpPublicComponent } from './dialog-evernorth-help-public/dialog-evernorth-help-public.component';
import { DialogEvernorthHelpSecureComponent } from './dialog-evernorth-help-secure/dialog-evernorth-help-secure.component';
import { EvernorthHeaderUtilComponent } from './evernorth-header-util/evernorth-header-util.component';
import { DialogPrivacyComponent } from './dialog-privacy/dialog-privacy.component';
import { LoginRedirectComponent } from './login-redirect/login-redirect.component';
import { ImpersonateRedirectComponent } from './impersonate-redirect/impersonate-redirect.component';

import { UnavailableComponent } from './unavailable/unavailable.component';
import { LeafLoadingSpinner, LeafIconNext } from '@cigna/leaf-web/lib/angular';
@NgModule({
  imports: [
    CommonModule,
    ChcpShellUiModule,
    ChcpSharedUiModule,
    UiIconModule,
    UiButtonModule,
    UiInputModule,
    UiModalModule,
    AnalyticsUiModule,
    RouterModule,
    MatDialogModule,
    UiProgressModule,
    UiCollapsibleModule,
    ChcpSharedEnvironmentUtilModule,
    LeafLoadingSpinner,
    LeafIconNext,
  ],
  declarations: [
    EvernorthHeaderComponent,
    EvernorthFooterComponent,
    EvernorthLogoComponent,
    EvernorthSearchComponent,
    DialogEvernorthHelpPublicComponent,
    DialogEvernorthHelpSecureComponent,
    EvernorthHeaderUtilComponent,
    DialogPrivacyComponent,
    LoginRedirectComponent,
    ImpersonateRedirectComponent,
    UnavailableComponent,
  ],
  exports: [
    EvernorthHeaderComponent,
    EvernorthFooterComponent,
    DialogEvernorthHelpPublicComponent,
    DialogEvernorthHelpSecureComponent,
    LoginRedirectComponent,
    ImpersonateRedirectComponent,
    UnavailableComponent,
  ],
})
export class EvernorthProviderShellUiModule {}
